(function () {
  'use strict';

  function initSlider(root) {
    var slider = root.querySelector('.split-testimonials__slider');
    var prevBtn = root.querySelector('.split-testimonials__arrow--prev');
    var nextBtn = root.querySelector('.split-testimonials__arrow--next');
    if (!slider) return;

    function cardWidth() {
      var card = slider.querySelector('.testimonial-card');
      if (!card) return slider.clientWidth;
      var gap = parseFloat(getComputedStyle(slider).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCards(direction) {
      slider.scrollBy({ left: direction * cardWidth(), behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCards(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCards(1);
      });
    }
  }

  function init() {
    var sections = document.querySelectorAll('.split-testimonials');
    sections.forEach ? sections.forEach(initSlider) : Array.prototype.forEach.call(sections, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.split-testimonials');
    if (section) initSlider(section);
  });
})();
